import {Box, Grid, GridItem, HStack, Link, Separator, Stack, Text} from "@chakra-ui/react";
import NextLink from "next/link";
import {Container} from "./Container";
import {Logo} from "./Logo";

type SubPage = {text: string; href: string; subheading?: string};
export type Section = {text: string; to?: string; subpages: SubPage[]};

export const SECTIONS: Section[] = [
  {
    text: "Product",
    subpages: [
      {text: "AI Auditor", href: "/financial-audit", subheading: "Solutions"},
      {text: "Control Assurance", href: "/control-assurance", subheading: "Features"},
      {text: "Risk Assessment Engine", href: "/risk-assessment-engine"},
    ],
  },
  {
    text: "Company",
    subpages: [
      {text: "Blog", href: "/blog"},
      {text: "Customers", href: "/customers"},
      {text: "Our Trust Center", href: "https://trust.platformed.com/platformed"},
      {text: "About", href: "/about"},
      {text: "Careers", href: "/careers"},
    ],
  },
  {
    text: "Legal",
    subpages: [
      {text: "Companies House", href: "https://find-and-update.company-information.service.gov.uk/company/14622305?"},
      {text: "Privacy", href: "/privacy"},
      {text: "Terms of Use", href: "/terms"},
      {text: "ICO", href: "https://ico.org.uk/ESDWebPages/Entry/ZB549448"},
    ],
  },
];

const Footer = () => (
  <Box
    pt={16}
    pb={10}
    bg="gray.900"
    color="white"
    bgGradient="to-br"
    gradientFrom="gray.800"
    gradientTo="gray.900"
    borderTop="1px solid black"
  >
    <Container>
      <Stack gap={10}>
        <HStack gap={10} justify="space-between" align="flex-start" flexWrap="wrap">
          <Link asChild minW={["full", "full", 1]} flex={1}>
            <NextLink href="/">
              <Logo light h={5} w="auto" />
            </NextLink>
          </Link>
          <Grid
            columnGap={16}
            rowGap={16}
            templateColumns={["repeat(2, 1fr)", "repeat(3, 1fr)", "repeat(3, 1fr)", "repeat(4, 1fr)"]}
            pr={4}
          >
            {SECTIONS.map((s, i) => (
              <GridItem as={Stack} gap={4} key={i}>
                {s.to ? (
                  <Link asChild fontSize="sm" fontWeight="700" color="gray.100">
                    <NextLink href={s.to}>{s.text}</NextLink>
                  </Link>
                ) : (
                  <Box fontSize="sm" fontWeight="700" color="gray.100">
                    {s.text}
                  </Box>
                )}
                {s.subpages.map((page, j) => {
                  const showSubheading = page.subheading && (j === 0 || s.subpages[j - 1]?.subheading !== page.subheading);
                  return (
                    <>
                      {showSubheading && (
                        <Text key={`subheading-${j}`} fontSize="2xs" fontWeight="600" color="gray.400" textTransform="uppercase" letterSpacing="wider" mt={j > 0 ? 2 : 0}>
                          {page.subheading}
                        </Text>
                      )}
                      <Link
                        key={j}
                        asChild
                        color="gray.300"
                        fontSize="sm"
                        target={page.href.startsWith("http") ? "_blank" : undefined}
                      >
                        <NextLink href={page.href}>{page.text}</NextLink>
                      </Link>
                    </>
                  );
                })}
              </GridItem>
            ))}
          </Grid>
        </HStack>
        <Separator borderColor="gray.700" />
        <Box fontSize="xs" fontWeight="400" color="gray.500">
          Copyright {new Date().getUTCFullYear()} Platformed Ltd
        </Box>
      </Stack>
    </Container>
  </Box>
);

export default Footer;
